import { getAttractivePrice } from 'core/common/utils/getAttractivePrice';
import { Offer, UpsellDeprecated, UpsellContent } from '../entities';

const contentPricePlaceholder = '-';

const getContentPrice = (value: string | undefined) => {
  const trimmedValue = value?.trim();

  if (!trimmedValue || trimmedValue === contentPricePlaceholder) {
    return null;
  }

  return trimmedValue;
};

const getCalculatedOldPrice = (discountPercentage: number | undefined, upsellData: Offer) => {
  if (!discountPercentage) {
    return '';
  }

  const { price, currencySymbol } = upsellData;

  return `${currencySymbol}${getAttractivePrice(price / (1 - discountPercentage))}`;
};

/** @deprecated **/
export const getCalculatedUpsell = <T extends UpsellContent>(
  initUpsell: T,
  upsellData: Offer | null,
): T & Pick<Required<UpsellDeprecated>, 'offerId' | 'price' | 'oldPrice'> => {
  if (!upsellData) {
    return {
      ...initUpsell,
      price: '',
      oldPrice: '',
      offerId: '',
    };
  }

  const price = getContentPrice(initUpsell.price) ?? upsellData.priceWithCurrency;
  const oldPrice =
    getContentPrice(initUpsell.oldPrice) ??
    getCalculatedOldPrice(initUpsell.discountPercentage, upsellData);

  return {
    ...initUpsell,
    price,
    oldPrice,
    offerId: upsellData.offerId,
  };
};
